import { render, staticRenderFns } from "./EtapaDadosVeiculo.vue?vue&type=template&id=1cf34089"
import script from "./EtapaDadosVeiculo.vue?vue&type=script&lang=js"
export * from "./EtapaDadosVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports